import React from 'react';
import usePageData from '../helpers/usePageData';

const MentionsLegales = () => {
    const { data: pageData, loading } = usePageData('mentions-legales');

    if (loading || !pageData) return null;

    return (
        <div className="mentions-legales">
            {/* Hero Section */}
            <section className="bg-dark text-white py-5">
                <div className="container py-5 text-center">
                    <h1 className="display-4 fw-bold mb-4">
                        {pageData.hero.title.includes('LÉGALES') ? (
                            <>{pageData.hero.title.split('LÉGALES')[0]}<span className="text-warning">LÉGALES</span></>
                        ) : pageData.hero.title}
                    </h1>
                    <p className="fs-5 mx-auto" style={{ maxWidth: '800px' }}>
                        {pageData.hero.subtitle}
                    </p>
                </div>
            </section>

            {/* Main Content Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            {pageData.sections.map((section, index) => (
                                <div className="mb-5" key={index}>
                                    <h2 className="h3 fw-bold mb-3">{section.title}</h2>

                                    {section.link && (
                                        <div className="d-flex align-items-center mb-3">
                                            <div>
                                                <p className="fs-5 fw-bold mb-1">
                                                    <a href={section.link.url} className="text-warning" target="_blank" rel="noopener noreferrer">{section.link.label}</a>
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {section.lines && (
                                        <div className="fs-5 text-muted mb-3">
                                            {section.lines.map((line, i) => (
                                                <p key={i} className="mb-1">{line}</p>
                                            ))}
                                        </div>
                                    )}

                                    {section.content && (
                                        <p className="fs-5 text-muted mb-3">{section.content}</p>
                                    )}

                                    {section.paragraphs && section.paragraphs.map((p, i) => (
                                        <p key={i} className="fs-5 text-muted mb-3">{p}</p>
                                    ))}

                                    {section.list && (
                                        <ul className="fs-5 text-muted">
                                            {section.list.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    )}

                                    {section.footer && (
                                        <p className="fs-5 text-muted mt-3">{section.footer}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MentionsLegales;
